import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-12" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "text-sm text-gray-600 mb-4" }
const _hoisted_4 = { class: "flex flex-row items-start" }
const _hoisted_5 = { class: "w-1/4 px-2" }
const _hoisted_6 = { class: "w-1/4 px-2" }
const _hoisted_7 = { class: "w-1/4 px-2" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = {
  key: 0,
  class: "mt-4 px-4 py-3 border border-yellow-300 bg-yellow-50 text-sm text-yellow-800 rounded"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_11 = { class: "text-medium text-center p-3 mb-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("report.performance.title")), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("report.performance.description")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_FormInput, {
          elementData: _ctx.state.monthElementData,
          initialState: _ctx.state.monthInitialState,
          onFormInputValueUpdate: _ctx.methods.monthChange
        }, null, 8, ["elementData", "initialState", "onFormInputValueUpdate"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FormInput, {
          elementData: _ctx.state.carrierElementData,
          values: _ctx.state.filtersValue,
          initialState: { value: _ctx.state.filtersValue.suppliers },
          onFormInputValueUpdate: _ctx.methods.filterChange
        }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_FormInput, {
          elementData: _ctx.state.countryElementData,
          values: _ctx.state.filtersValue,
          initialState: { value: _ctx.state.filtersValue.countries },
          onFormInputValueUpdate: _ctx.methods.filterChange
        }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_default_button, {
          "injected-class": "px-6 py-3 mt-2 ml-4",
          disabled: _ctx.state.isDownloading || !_ctx.state.hasTrackingData,
          onClick: _ctx.methods.downloadPdf
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("report.performance.download_pdf")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_default_button, {
          "injected-class": "px-6 py-3 mt-2 ml-2",
          disabled: _ctx.state.isDownloading || !_ctx.state.hasTrackingData,
          onClick: _ctx.methods.downloadXlsx
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("report.performance.download_xlsx")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    (_ctx.state.carriersLoaded && !_ctx.state.hasTrackingData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("report.performance.no_tracking_data")), 1))
      : _createCommentVNode("", true),
    (_ctx.state.isDownloading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_spinner, { class: "mx-auto" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      type: "warning",
      size: "small",
      hideCancelButton: true,
      modelValue: _ctx.state.showModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.showModal) = $event)),
      onConfirmClick: _ctx.methods.closeModal,
      onCancelClick: _ctx.methods.closeModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("report.performance.modal.title")), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.state.modalMessage)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick", "onCancelClick"])
  ]))
}